<div class="doc-wrap">

  <!-- Skeleton -->
  @if (loading) {
    <div class="doc-skeleton">
      <div class="doc-sk-title"></div>
      @for (_ of [1,2,3,4,5,6]; track $index) {
        <div class="doc-sk-row"></div>
      }
    </div>
  }

  @if (!loading && config) {

    <!-- Header -->
    <div class="doc-header">
      <span class="doc-title">{{ config.title }}</span>
      <span class="doc-total-badge">{{ totalCount | number }} detecciones</span>
    </div>

    <!-- Tag filters -->
    <div class="doc-tag-bar">
      @for (t of tags; track t.key) {
        <button type="button" class="doc-tag-btn"
                [class.is-active]="activeTag === t.key"
                [style.--tag-color]="t.color"
                (click)="selectTag(t.key)">
          {{ t.label }}
        </button>
      }
    </div>

    <!-- Object list -->
    @if (filtered.length === 0) {
      <div class="doc-empty">Sin objetos detectados.</div>
    } @else {
      <ul class="doc-list">
        @for (item of filtered; track trackByName($index, item)) {
          <li class="doc-item">

            <!-- Tag pill + name -->
            <div class="doc-item__left">
              <span class="doc-item__tag-pill"
                    [style.background]="item.meta.bg"
                    [style.color]="item.meta.color">
                {{ item.meta.label }}
              </span>
              <span class="doc-item__name" [title]="item.name">{{ item.name }}</span>
            </div>

            <!-- Score bar + count -->
            <div class="doc-item__right">
              <div class="doc-score-bar">
                <div class="doc-score-bar__fill"
                     [style.width.%]="scorePct(item.avgScore)"
                     [style.background]="item.scoreColor">
                </div>
              </div>
              <span class="doc-score-label" [style.color]="item.scoreColor">
                {{ scorePct(item.avgScore) }}%
              </span>
              <span class="doc-item__count">×{{ item.count }}</span>
            </div>

          </li>
        }
      </ul>
    }

  }

</div>
